import React from 'react';
import { Card } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import './TransactionPageSkeleton.css';

/**
 * Mirrors TransactionHistory page:
 *  - Header: "Transaction History" h4
 *  - TransactionDetailCard (Accordion)
 *  - TransactionDetailTable (tabs + table)
 */
const TransactionPageSkeleton: React.FC = () => (
  <>
    {/* Header */}
    <div className="d-flex justify-content-between align-items-center mb-4">
      <Skeleton width={200} height={28} borderRadius={6} />
    </div>

    {/* TransactionDetailCard — Accordion */}
    <div className="mt-4">
      <Card className="shadow-sm border-0 rounded-4">
        <Card.Body>
          <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
            <div className="d-flex align-items-center gap-3">
              <Skeleton width={50} height={50} borderRadius={9} />
              <Skeleton width={160} height={22} borderRadius={6} />
            </div>
            <div className="d-flex align-items-center gap-3">
              <div>
                <Skeleton width={100} height={24} borderRadius={6} style={{ marginBottom: 4 }} />
                <Skeleton width={80} height={13} borderRadius={6} />
              </div>
              <Skeleton width={140} height={42} borderRadius={8} />
            </div>
          </div>
        </Card.Body>
      </Card>
    </div>

    {/* TransactionDetailTable */}
    <div className="mt-4">
      <Card className="shadow-sm border-0 rounded-4">
        <Card.Body>
          {/* Tabs */}
          <div style={{ borderBottom: '1px solid #eaeaea', marginBottom: 15 }}>
            <div className="d-flex gap-3 mb-4">
              <Skeleton width={100} height={16} borderRadius={6} />
              <Skeleton width={70} height={16} borderRadius={6} />
            </div>
          </div>
          {/* Table header */}
          <div className="d-flex gap-3 py-2" style={{ borderBottom: '1px solid #f0f0f0' }}>
            <Skeleton width={18} height={18} borderRadius={4} />
            {[80, 90, 120, 70, 60, 56].map((w, i) => (
              <Skeleton key={i} width={w} height={13} borderRadius={6} />
            ))}
          </div>
          {/* Rows */}
          {[...Array(6)].map((_, i) => (
            <div key={i} className="d-flex align-items-center gap-3 py-3" style={{ borderBottom: '1px solid #f8f8f8' }}>
              <Skeleton width={18} height={18} borderRadius={4} style={{ flexShrink: 0 }} />
              <Skeleton width={80} height={13} borderRadius={6} />
              <Skeleton width={90} height={13} borderRadius={6} />
              <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                <Skeleton width={80} height={13} borderRadius={6} />
                <Skeleton width={50} height={11} borderRadius={6} />
              </div>
              <Skeleton width={65} height={24} borderRadius={999} />
              <Skeleton width={50} height={13} borderRadius={6} />
              <div className="d-flex gap-2">
                <Skeleton circle width={16} height={16} />
                <Skeleton circle width={16} height={16} />
              </div>
            </div>
          ))}
        </Card.Body>
      </Card>
    </div>
  </>
);

export default TransactionPageSkeleton;
